import Vue from 'vue';

const success = (context, response) => {
    context.defaultTemplates = response.data.default_templates;
    context.userTemplates = response.data.user_templates;
    context.addNewFeldToTemplates('set');
};

const failed = (context) => {
    toastr.error("Something went wrong");
};

export default (context) => {
    return Vue.$http.get('message-templates').then(response => {
      if(response.status === 200) {
        success(context, response);
      }
    }).catch(error => {
      failed(context);
    })
};



// WEBPACK FOOTER //
// ./src/app/services/message-template/getTemplates.js